//@flow
import React from 'react';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  theme: string,
  data: {
    banner: any,
  },
  fullpageApi: {
    moveSectionDown: () => void, // TODO:
  },
};

const LoyaltyBanner = (props: Props) => {
  const { height, isMobile } = useViewport();

  const { theme, fullpageApi } = props;
  const {
    loyaltyBanner: {
      title,
      description,
      description_mobile,
      image,
      image_mobile,
      thumbnail,
      thumbnail_mobile,
      banner_video,
    },
  } = props.data;
  let className = 'loyalty-banner';
  let imageUrl = image;
  let thumbNail = thumbnail;

  const handleClick = () => {
    fullpageApi.moveSectionDown();
  };

  let bannerText = title;
  if (isMobile) {
    imageUrl = image_mobile;
    thumbNail = thumbnail_mobile;
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        containerClassName={'loyalty-banner-image'}
        imageUrl={imageUrl}
        thumbNailUrl={thumbNail}
        title={bannerText}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {isMobile && (
        <FooterExploreButton
          theme={theme}
          onClick={handleClick}
          sectionName={'#'}
        />
      )}
    </div>
  );
};

export default LoyaltyBanner;
